/* jshint esversion: 6 */
import 'core-js'; // has to be on top of entry point
import '@fortawesome/fontawesome-pro';
import 'bootstrap';
import './slidingLabel';
import './confirmationModal';
import './accordion';

if ($('#dataTable').length > 0) {
    import('./crud-datatables');
}

export function addJSError(error) {
    let fieldIdentifier = (function (error) {
        let identifier = error,
            identifierEnd = error.search('_');
        if (identifierEnd !== -1) {
            identifier = error.substring(0, identifierEnd);
        }
        return identifier;
    })(error);
    $('.jSErrorMessages').removeClass('d-none');
    $('#' + fieldIdentifier).each(function () {
        $(this).addClass('f3-form-error');
    });
    $('.iw-' + fieldIdentifier + 'Error').each(function () {
        $(this).removeClass('d-none');
    });
}
export function removeJSErrors() {
    $('.jSErrorMessages, .jSErrorMessages div').addClass('d-none');
    $('input, textarea').removeClass('f3-form-error');
}

$(function () {
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();

    /* Basket logic */
    let quantityField = $('.iw-quantityAction .iw-quantityField');

    quantityField.on('click', function(){
        $(this).focus();
    });

    quantityField.on('blur', function () {
        $(this).closest('.iw-quantityAction').submit();
    });

    $('.iw-quantityAction').on('submit', function (event) {
        const quantityField = $(this).find('.iw-quantityField'),
            quantity = parseFloat(quantityField.val());

        if (isNaN(quantity) || Math.floor(quantity) !== quantity || quantity < 1) {
            event.preventDefault();
            quantityField.addClass('f3-form-error');
            $('.iw-basketContainer .iw-primaryButton').addClass('iw-disabled');
            $('.iw-basketContainer .iw-primaryButton input').attr('disabled', true);
        } else {
            $('.loadingIndicator').removeClass('d-none');
            quantityField.removeClass('f3-form-error');
            $('.iw-basketContainer .iw-primaryButton').removeClass('iw-disabled');
            $('.iw-basketContainer .iw-primaryButton input').attr('disabled', false);
        }
    });

    $('.iw-removeAction').on('submit', function () {
        $('.loadingIndicator').removeClass('d-none');
    });

    if (document.getElementById('SelfPrintProduct') || document.getElementById('MobileProduct')) {
        import('./selfPrint');
    }

    /* Address-Form */

    $('#addressForm .iw-addressSelection input[type="radio"]').on('change', function () {
        if ($('#addressForm .iw-deliveryAddress #deliveryAddress-country-description').length > 0) {
            $('#addressForm #deliveryAddressDiffering0').prop('checked', false);
            $('#addressForm #deliveryAddressDiffering1').prop('checked', true);
            $('#addressForm .iw-deliveryAddress').removeClass('d-none');
            return;
        }

        if (!$(this).is(':checked')) {
            return;
        }

        if (parseInt($(this).val()) === 1) {
            $('#addressForm .iw-deliveryAddress').removeClass('d-none');
        } else {
            $('#addressForm .iw-deliveryAddress').addClass('d-none');
        }
    }).change();

    $('#addressForm #invoiceAddressCountry').on('change', function () {
        $('#addressForm .iw-deliveryAddress #deliveryAddress-country-description').remove();
    });

    $('#addressForm .iw-deliveryAddressSelect').on('click', function () {
        deselectAllAddresses();
        $(this).find('.iw-deliveryAddressSelectedSymbol').removeClass('d-none');
        $(this).addClass('border-dark');
        $('#' + $(this).data('deliveryAddress')).prop('checked', true);
        $('.iw-primaryButtonContainer').removeClass('iw-disabled');
        $('.iw-primaryButtonContainer input').attr('disabled', false);
    });

    $('#addressForm .iw-customAddress').on('click', function () {
        deselectAllAddresses();
    });

    if ($('.customAddressModal input.form-control.f3-form-error').length > 0) {
        $('.customAddressModal').modal('show');
    }

    function deselectAllAddresses() {
        $('#addressForm .iw-deliveryAddressSelect .iw-deliveryAddressSelectedSymbol').addClass('d-none');
        $('#addressForm .iw-deliveryAddressSelect').removeClass('border-dark');
        $('.iw-primaryButtonContainer').addClass('iw-disabled');
        $('.iw-primaryButtonContainer input').attr('disabled', true);
    }

    /* Standard & MultiStepIndividual product logic */
    if (document.getElementsByClassName('jSErrorMessages').length > 0) {
        $('#StandardProduct, #MultiStepIndividualProduct').submit(function (event, accepted) {
            if (!accepted) {
                removeJSErrors();

                const valid = (function () {
                    let valid = true,
                        $loadValue = $('#loadValue'),
                        loadValue = $loadValue.val().replace(/\s/, '').replace(',', '.'),
                        parsedLoadValue = parseFloat(loadValue),
                        loadValueConfig = $loadValue.data(),
                        regEx = /^\d+(\.\d*)?$/,
                        isNan = (!regEx.test(loadValue) || isNaN(parsedLoadValue));

                    if (isNan || parsedLoadValue > loadValueConfig.max || parsedLoadValue < loadValueConfig.min) {
                        let forLoadValueError = isNan ? 'loadValue_nan' : 'loadValue_range';
                        valid = false;
                        addJSError(forLoadValueError);
                        $(window).scrollTop(0);
                    } else {
                        $loadValue.val(parseFloat(loadValue).toFixed(2).replace('.', ','));
                    }

                    return valid;
                })();

                if (!valid) {
                    event.preventDefault();

                }
            }
        });
    }

    /* Individual product logic */

    if (document.getElementById('myMotif')) {
        import('./individual');
    }

    /* Payment logic */

    $('.iw-chosePaymentContainer .iw-primaryButtonContainer').on('click', function () {
        if (!$('input[name ="paymentAdapter"]').is(':checked')) {
            return;
        }
        $('.iw-chosePaymentContainer').hide();
        $('.iw-submitPaymentContainer').show();
    });

    $('.iw-submitPaymentContainer .iw-paymentBackButton').on('click', function () {
        $('.iw-submitPaymentContainer').hide();
        $('.iw-chosePaymentContainer').show();
    });

    $('.iw-chosePaymentContainer input[name="paymentAdapter"]').on('change', function () {
        if ($(this).is(':checked')) {
            let paymentInformationContainer = $('.iw-paymentInformationContainer input[name ="paymentAdapter"]:checked').closest('.iw-paymentInformationContainer');
            $('.iw-submitPaymentContainer .iw-selectedPaymentTitle').text(paymentInformationContainer.find('.iw-selectedPaymentTitle').text());
            $('.iw-submitPaymentContainer .iw-selectedPaymentDescription').text(paymentInformationContainer.find('.iw-selectedPaymentDescription').text());
            $('.iw-submitPaymentContainer .iw-selectedPaymentImage').html(paymentInformationContainer.find('.iw-selectedPaymentImage').html());

            $('.iw-chosePaymentContainer .iw-primaryButtonContainer').removeClass('iw-disabled');
        } else {
            $('.iw-chosePaymentContainer .iw-primaryButtonContainer').addClass('iw-disabled');
        }
    }).change();

    $('#termsAndConditions').on('change', function () {
        if ($(this).is(':checked')) {
            $('.iw-submitPaymentContainer .iw-submitButtonContainer').removeClass('iw-disabled');
            $('.iw-submitPaymentContainer .iw-submitButtonContainer input').attr('disabled', false);
        } else {
            $('.iw-submitPaymentContainer .iw-submitButtonContainer').addClass('iw-disabled');
            $('.iw-submitPaymentContainer .iw-submitButtonContainer input').attr('disabled', true);
        }
    }).change();

    $('#orderForm').on('submit', function () {
        $('.iw-submitPaymentContainer .iw-submitButtonContainer').addClass('iw-disabled');
        $('.iw-submitPaymentContainer .iw-submitButtonContainer input').attr('disabled', true);
    });

    /* Registration */
    $('#privacyTerms').on('change', function() {
        if ($(this).is(':checked')) {
            $('#registerCompanyButton').removeClass('iw-disabled');
            $('#registerCompanyButton').attr('disabled', false);
        } else {
            $('#registerCompanyButton').addClass('iw-disabled');
            $('#registerCompanyButton').attr('disabled', true);
        }
    }).change();

    $('.iw-characterCounter').on('keyup', function () {
        setCounterTargetText(this);
    });

    $('.iw-characterCounter').each(function() {
        setCounterTargetText(this);
    });

    function setCounterTargetText(object) {
        $($(object).data('countertarget')).text($(object).val().length + '/' + $(object).attr('maxlength'));
    }
});
